import React from "react";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import { CACHE_RELEASE_APP_VERSION } from "src/constants/actionCache";
import ShowCacheReleaseAppVersion from "../ShowCache/ShowCacheReleaseAppVersion";
import ReleaseAppVersionPopup from "../Popup/ReleaseAppVersionPopup";

const ReleaseAppVersionControlPanel = ({
  children,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Release App Version"
          isShowButton={isShowCache(
            currentActionCache,
            CACHE_RELEASE_APP_VERSION
          )}
        >
          <ShowCacheReleaseAppVersion
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        <ReleaseAppVersionPopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default ReleaseAppVersionControlPanel;
